import React, {FC, useContext} from 'react';
import removeItem from '../../store/actions/remove-item';
import updateItem from '../../store/actions/update-item';
import {CommercialProduct} from '../../types/commercial-product';
import documentContext from '../document-context/document-context';
import messages from './messages';
import Icon from '@ailibs/feather-react-ts/dist/Icon';
import Button from 'components/button';
import TextInput from 'components/text-input';
import {useTranslation} from 'react-i18next';
import {useDispatch} from 'react-redux';
import {Col, Row} from 'reactstrap';
import ItemRemovalButton from '../../components/item-removal-button/item-removal-button';

interface Props {
  index: number;
  item: CommercialProduct;
  dragHandleProps?: any;
}

const ItemTitle: FC<Props> = props => {
  const {item, index, dragHandleProps} = props;

  const dispatch = useDispatch();

  const handleUpdate = (key: keyof CommercialProduct, v: any) => {
    dispatch(updateItem(item, key, v));
  };

  const handleRemoveLine = () => {
    dispatch(removeItem(item.id));
  };

  const {validationErrors, is_locked} = useContext(documentContext);

  const {t} = useTranslation();

  return (
    <div>
      <Row className="pb-3">
        <Col md="auto">
          <Button
            color="link"
            disabled={is_locked}
            size="sm"
            className="dragHandle p-0"
            {...dragHandleProps}
          >
            <Icon name="menu" color="gray" size={20} />
          </Button>
        </Col>
        <Col>
          <TextInput
            label={t(...messages.title())}
            errors={validationErrors[`products.${index}.custom_name`]}
            value={item.custom_name}
            disabled={is_locked}
            onChange={p => handleUpdate('custom_name', p)}
          />
        </Col>
        <Col md="auto" className="text-end align-items-center d-flex">
          <ItemRemovalButton item={item} />
        </Col>
      </Row>
    </div>
  );
};

export default ItemTitle;
